export default __webpack_public_path__ + "static/media/NotoSans-BoldItalic.76723fb3.woff";